import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Link } from "react-router-dom";
import { Newspaper, HelpCircle, Mail, Plus, FileText, MessageSquare } from "lucide-react";

function formatDate(iso) {
  if (!iso) return "—";
  try { return new Date(iso).toLocaleString("de-DE"); } catch { return "—"; }
}

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);
  useEffect(() => { api.get("/admin/stats").then((r) => setStats(r.data)); }, []);

  return (
    <div data-testid="admin-dashboard">
      <h1 className="font-semibold text-3xl mb-2">Dashboard</h1>
      <p className="text-neutral-500 mb-10 text-sm">Übersicht über die wichtigsten Kennzahlen.</p>

      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5 mb-12">
        <Stat label="Veröffentlichte News" value={stats?.news_published ?? "—"} icon={Newspaper} />
        <Stat label="FAQs" value={stats?.faqs_total ?? "—"} icon={HelpCircle} />
        <Stat label="Newsletter-Abonnenten" value={stats?.newsletter_active ?? "—"} icon={Mail} />
        <Stat label="Offene Anliegen" value={stats?.contacts_new ?? "—"} icon={MessageSquare} />
      </div>

      <p className="text-xs text-neutral-400 mb-4">Letzte News-Aktualisierung: {formatDate(stats?.last_news_updated)}</p>

      <div className="bg-white border border-brand-line p-8">
        <h2 className="font-semibold text-xl mb-6">Schnellzugriff</h2>
        <div className="grid sm:grid-cols-3 gap-3">
          <QuickLink to="/admin/news/new" icon={Plus} label="Neue News" />
          <QuickLink to="/admin/faqs" icon={HelpCircle} label="FAQs pflegen" />
          <QuickLink to="/admin/startseite" icon={FileText} label="Startseite bearbeiten" />
        </div>
      </div>
    </div>
  );
}

function Stat({ label, value, icon: Icon }) {
  return (
    <div className="bg-white border border-brand-line p-6" data-testid={`stat-${label}`}>
      <div className="flex items-center justify-between mb-4">
        <span className="text-xs uppercase tracking-wider text-neutral-500">{label}</span>
        <Icon className="h-4 w-4 text-[hsl(var(--brand-green-strong))]" />
      </div>
      <p className="font-semibold text-4xl">{value}</p>
    </div>
  );
}

function QuickLink({ to, icon: Icon, label }) {
  return (
    <Link to={to} className="flex items-center gap-3 border border-brand-line px-4 py-4 hover:bg-[hsl(var(--brand-soft))] transition-colors text-sm">
      <Icon className="h-4 w-4 text-[hsl(var(--brand-green-strong))]" /> {label}
    </Link>
  );
}
